__webpack_require__.p = "https://bmidxbhungaryplpreprod.netlify.app/";